module.exports = __webpack_public_path__ + "static/media/bearings3.6e29682e.jpeg";